"use strict";

/**
 *
 * Работа с корзиной
 * @namespace Fotobook.cart
 */
Fotobook.cart = {
    cartUrl: '/cart',
    isCanceled: false,

    /** Проверка проекта на качество */
    checkProjectQuality(id) {
        Fotobook.cart.isCanceled = false;
        const $processDialog = Fotobook.cart.processDialog();

        return new Promise((resolve, reject) => {
            Fotobook.ajax.getJSON('/base/quality-check/check-project', {
                longQueryTimeout: false,
                data: {
                    id,
                },
            }).then((response) => {
                if (Fotobook.cart.isCanceled) {
                    return;
                }
                const qualityCheck = response.data.qualityCheck;
                Fotobook.dialog.confirm(Fotobook.cart.qualityCheckMessage(qualityCheck), {
                    title: t('photobook-js-addToCartDialogTitle'),
                    width: 400,
                    buttonResolve: t('photobook-js-buttonsShow'),
                    buttonReject: t('photobook-js-buttonsIgnore'),
                    showButtonReject: Fotobook.config.data[Fotobook.Settings.GENERATE_INCOMPLETE] && !qualityCheck.no_original && !qualityCheck.substrate_missing,
                    closeButtonAction: 'none',
                    fotobookDialogClass: 'autotest-project-ordering-dialog',
                    // если нет проблем - виртуально жмём кнопку "игнорировать" в диалоге
                    rejected: !qualityCheck.low_quality && !qualityCheck.empty && !qualityCheck.no_original && !qualityCheck.substrate_missing,
                }).then(async () => {
                    // показываем ошибки
                    await Fotobook.store.dispatch('bottomPanel/setShowBookErrors', true);

                    // установить тип таба принудительно
                    // пока мы не можем юзать импорты, передаём 1 (что идентично TAB_PAGES)
                    // после переписывания данного модуля на Vue можно будет передать таб как надо
                    // await Fotobook.store.dispatch('bottomTabs/setActiveTab', Fotobook.bottomPanel.TAB_PAGES);
                    await Fotobook.store.dispatch('bottomTabs/setActiveTab', 1);
                    reject();
                }).catch(resolve);
            }).finally(() => {
                Fotobook.dialog.close($processDialog);
            });
        });
    },

    qualityCheckMessage: function (qualityCheck) {
        var content = [],
            message = '<div class="bold">' + t('photobook-js-messageCheckBook') + '</div><br>';

        if (qualityCheck.empty_fotowindow) {
            content.push(t('photobook-js-messageEmptyFotowindows'));
        }
        if (qualityCheck.empty_foto) {
            content.push(t('photobook-js-messageEmptyPages'));
        }
        if (qualityCheck.low_quality_artefact) {
            content.push(t('photobook-js-messageLowResolutionArtefact'));
        }
        if (qualityCheck.low_quality_foto) {
            content.push(t('photobook-js-messageLowResolution'));
        }
        if (qualityCheck.no_original_foto) {
            content.push('<span style="color:red">' + t('photobook-js-noOriginal') + '</span>');
        }
        if (qualityCheck.low_quality_bg) {
            content.push(t('photobook-js-messageLowResolutionBg'));
        }
        if (qualityCheck.no_original_bg) {
            content.push('<span style="color:red">' + t('photobook-js-messageBgNoOrig') + '</span>');
        }
        if (qualityCheck.no_original_artefact) {
            content.push('<span style="color:red">' + t('photobook-js-messageArtefactNoOrig') + '</span>');
        }
        if (qualityCheck.substrate_missing) {
            content.push(t('photobook-js-messageProjectColorMissing'));
        }

        if (content.length) {
            message += "&mdash; " + content.join("<br>&mdash; ") + '<br>';
        }
        return message;
    },

    /** добавить проект в корзину */
    orderProject: function(id){
        var proccessDialog = Fotobook.dialog.alert(t("photobook-js-orderingProject") + Fotobook.projectChecking + "<br>" + t("photobook-js-pleaseWait") + "...", {
            "title": t("photobook-js-orderingProject"),
            "width": 406,
            "showButtonResolve": false,
        });

        return new Promise((resolve, reject) => {
            Fotobook.ajax.post("/cart/order/add-project", {
                data: {
                    id: parseInt(id, 10),
                },
                longQueryTimeout: false,
            }).then(() => {
                window.location.replace(Fotobook.cart.cartUrl);
                resolve();
            }).catch(
                reject
            ).finally(() => {
                Fotobook.dialog.close(proccessDialog);
            });
        });
    },

    processDialog: function () {
        const $dialog = Fotobook.dialog.alert(t('photobook-js-checkingPhotoQuality') + Fotobook.projectChecking, {
            title: t("photobook-js-addToCartDialogTitle"),
            width: 400,
            buttonResolve: t("photobook-js-buttonsCancel")
        });

        $dialog.then(
            () => {
                Fotobook.cart.isCanceled = true;
            },
            () => null
        );
        return $dialog;
    },

};
